import classNames from 'classnames';
import React from 'react';
import { Route } from 'react-router-dom';

import LinkWithContext, { ToObjectType } from 'sharedreact/components/LinkWithContext';

type Props = {
  id: string,
  className?: string,
  activeOnlyWhenExact?: boolean,
  to: string | ToObjectType,
  allowLargeText?: boolean,
  children?: React.ReactNode,
  onClick?: (goToLink: () => void) => boolean 
};

class NavigationBarLink extends React.Component<Props> {
  override render (): React.ReactNode {
    const {
      id, className, activeOnlyWhenExact, to,
      allowLargeText, children, onClick
    } = this.props;
    let toLocation: string | ToObjectType = to;
    if ((typeof to === 'string' || to instanceof String)) {
      const toParts: string[] = to.split('?');

      toLocation = {
        pathname: toParts[0],
        search: toParts.length > 1 ? toParts[1] : '',
        state: {keepSearch: true}
      };
    } else {
      toLocation = to;
    }

    return (
      <Route
        path={toLocation.pathname}
        exact={activeOnlyWhenExact}
        children={({ match }) => (
          <li className={classNames(className, { active: match })}>
            <LinkWithContext id={id}
              to={toLocation}
              className={
                allowLargeText ? 'esko_navbaritemtext-large' : 'esko_navbaritemtext'
              }
              onClick={onClick}>
              {children}
            </LinkWithContext>
          </li>
        )} />
    );
  }
}

export default NavigationBarLink;
